import React from 'react';
import Text from '@/common/view/Text';
import CustomerApiAgent from '../../main/agent/CustomerApiAgent';
import { useCustomerDetailPageContext } from '../datacontroller/CustomerDetailPageContext';
import { CustomerCartProductTable } from './CustomerCartProductTable';
import { CustomerWishlistProductTable } from './CustomerWishlistProductTable';

export const CustomerCartAndWishlistSection: React.FC = () => {
  const { customerId } = useCustomerDetailPageContext();

  const { data: cartProducts, isLoading: isCartLoading } = CustomerApiAgent.useGetCustomerCartProducts(customerId);
  const { data: wishlistProducts, isLoading: isWishlistLoading } =
    CustomerApiAgent.useGetCustomerWishlistProducts(customerId);

  // 로딩 중에는 렌더링하지 않음 (깜빡임 방지)
  if (isCartLoading || isWishlistLoading) {
    return null;
  }

  // 장바구니와 찜 상품이 모두 0개이면 렌더링하지 않음
  const hasCartProducts = cartProducts && cartProducts.length > 0;
  const hasWishlistProducts = wishlistProducts && wishlistProducts.length > 0;

  if (!hasCartProducts && !hasWishlistProducts) {
    return null;
  }

  return (
    <div className="w-full flex gap-3">
      <div className="w-full">
        <Text typo="subtitle3" color="grayBlack" className="my-2">
          장바구니 상품
        </Text>
        <CustomerCartProductTable data={cartProducts} isLoading={isCartLoading} />
      </div>
      <div className="w-full">
        <Text typo="subtitle3" color="grayBlack" className="my-2">
          찜 상품
        </Text>
        <CustomerWishlistProductTable data={wishlistProducts} isLoading={isWishlistLoading} />
      </div>
    </div>
  );
};
